import { render, staticRenderFns } from "./UpdateRI.vue?vue&type=template&id=53642eba"
import script from "./UpdateRI.vue?vue&type=script&lang=js"
export * from "./UpdateRI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports